import React, { useState, useEffect } from "react";
import "./SplashScreen.css";
import logo1 from "./assets/logo1.svg";
import logo2 from "./assets/logo2.svg";
const SplashScreen = () => {
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setHide(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`splash-screen ${hide ? "hide" : ""}`}>
      <img
        src={logo1}
        alt="Leoarch Logo"
        className="splash-logo"
      />
    </div>
  );
};

export default SplashScreen;